import React, { useEffect, useState } from "react";
import { Typography, Divider, Form, Button, Input, Space, Select, Checkbox, message, AutoComplete, Spin, Result, Alert, Popconfirm, Tabs } from "antd";
import ListUpload from "./ListUpload";
import { apiCall } from "../utils/Api";
import conditional from "../utils/conditional";
// import FilterPresetSelect from "./FilterPresetSelect";

export default function ListEdit(props) {

    const { callback = () => { }, create = false, data = {}, close = () => { }, results = {}, setResults = () => { } } = props;

    const [saving, setSaving] = useState(false);
    const [cats, setCats] = useState({ categories: [], subcategories: [] })
    const [canSave, setCanSave] = useState(true);
    const [form] = Form.useForm()

    const {
        list_id = "",
        is_dynamic = false,
        site_content = false,
        category = "Uncategorized",
        subcategory = "",
        sort_by = "",
        name = "",
        description = "",
        onhand_first = false,
        hide_non_oh_oo = false,
        sort_by_reversed = false,
        filter_preset_id = "",
    } = data;

    const [sort, setSort] = useState(sort_by);
    const [isPreset, setIsPreset] = useState((filter_preset_id));
    const [dynamic, setDynamic] = useState(is_dynamic);
    const [isbns, setIsbns] = useState([]);
    const [loading, setLoading] = useState(!create);

    const getISBNs = () => {
        if (create) { return; }
        apiCall("titlelist/getMyList", { list_id: list_id }, (_status, _result) => {
            if (_status) {
                setIsbns(_result.isbns);
            } else {
                message.error(_result.error)
            }
            setLoading(false);
        })
    }
    useEffect(getISBNs, []);

    const getCats = () => {
        apiCall("titlelist/getCurrentCategories", {}, (_status, _result) => {
            if (_status) {
                setCats(_result);
            }
        })
    }
    useEffect(getCats, [])

    const convertList = () => {
        let obj = { ...data }
        obj.is_dynamic = false;
        // obj.isbns_json = JSON.stringify(isbns.map(item => { return item.isbn }));
        apiCall("titlelist/edit", obj, (_status, _result) => {
            if (_status) {
                setDynamic(_result.is_dynamic);
                message.success("List converted successfully.")
            } else {
                message.error(_result.error);
            }
        })
    }

    const updateRow = (_result) => {


        let newArr = { ...results };
        let update = results.rows.find(item => item.list_id === _result.list_id);
        Object.keys(update).map(key => {
            update[key] = _result[key];
        })
        newArr.rows[results.rows.findIndex(item => item.list_id === _result.list_id)] = update;
        setResults({ ...results, "rows": newArr.rows })
    }

    const onFinish = (_f) => {

        setSaving(true)
        if (!_f.hasOwnProperty("description")) {
            _f.description = description;
        }

        // Don't send description if
        if (site_content) {
            delete _f["description"];
        }

        // Don't save isbns on edit
        if (!create) {

        } else {
            delete _f.list_id;
            // _f.isbns_json = f.isbns_json;
        }

        if (create) {
            apiCall("titlelist/create", _f, (_s, _r) => {
                if (_s) {
                    close();
                    message.success("List created successfully.");
                } else {
                    message.error(_r.error)
                }
                setSaving(false);
            })
        } else {
            apiCall("titlelist/replaceIsbns", { list_id: list_id, isbns_json: _f.isbns_json }, (_status, _result) => {
                if (_status) {
                    delete _f.isbns_json;
                    apiCall("titlelist/edit", _f, (_s, _r) => {
                        if (_s) {
                            close();
                            updateRow(_r);
                            message.success("List saved successfully.");
                        } else {
                            message.error(_r.error)
                        }
                        setSaving(false);
                    })
                } else {
                    message.error(_result.error)
                }
            })
        }
    }

    const updateList = (_list) => {
        form.setFieldsValue({ "isbns_json": JSON.stringify(_list) })
    }

    const drawDynamicWarning = () => {
        return (
            <Result
                icon={<></>}
                title=""
                type="warning"
                extra={
                    <Alert style={{ "maxWidth": "300px", "margin": "0 auto" }} description={
                        <>
                            <div>
                                <strong>List is dynamic</strong>
                                <div>This list is generated from search filters<br /> You can convert to a static, editable list by clicking below</div>
                                <br />
                                <div>
                                    <Popconfirm onConfirm={() => convertList()} title={<>Are you sure? <br />This action is irreversible</>} ><Button type="primary" size="small"><small>Convert to static list</small></Button></Popconfirm>
                                </div>
                            </div>
                        </>} />
                }
            />
        )
    }



    return (
        <>
            <div style={{ "padding": "20px" }}>
                <Typography.Title level={5}>{(create) ? "Create new" : "Edit"} List</Typography.Title>
                <Divider />
                <Spin spinning={loading}>
                    <Form form={form} onFinish={(e) => onFinish(e)} layout="vertical">

                        <Form.Item hidden initialValue={list_id} name="list_id" label="List name">
                            <Input />
                        </Form.Item>

                        <Space size={10} align="start">
                            <Form.Item initialValue={name} name="name" label="List name">
                                <Input placeholder="List name" style={{ "width": "300px" }} />
                            </Form.Item>
                        </Space>


                        <Form.Item initialValue={description} help="<a><b><i><u><br /> HTML tags allowed only" label="Description" name={"description"}>
                            <Input.TextArea placeholder="Description..." onChange={(e) => console.log(e)} rows={5} showCount maxLength={2000}></Input.TextArea>
                        </Form.Item>
                        <div className="shim" /><div className="shim" />

                        {((!loading) &&
                            <Spin indicator={<>{drawDynamicWarning()}</>} spinning={dynamic}>
                                <ListUpload candelete drag canSave={canSave} resetSort={() => {
                                    setSort("");
                                }} setCanSave={setCanSave} list_id={list_id} updateRow={updateRow} updateList={updateList} isbns={isbns} />
                                <Form.Item hidden initialValue={JSON.stringify(isbns.map(item => { return item.isbn }))} noStyle name={"isbns_json"}>
                                    <Input.TextArea rows={3} showCount maxLength={2000}></Input.TextArea>
                                </Form.Item>
                            </Spin>
                        )}
                        <Divider />
                        <div style={{ "float": "right" }}>
                            <Space>
                                <Button onClick={(e) => close()}>Cancel</Button>
                                <Button loading={saving} disabled={(!canSave)} htmlType="submit" type="primary">Save</Button>
                            </Space>
                        </div>
                        <br clear="all" />
                    </Form>
                </Spin>
            </div>
        </>
    );
}